export default __webpack_public_path__ + "d73a61417c2acca2a9ca294215369f80.jpeg";